module.exports = __webpack_public_path__ + "static/media/logo.c584da15.svg";